<template>
  <div class="gallery-filter">
    <div>

      <div class = "filter" v-if = "categories.includes('general')">
        <h3 v-if = "showTitles">General</h3>
        <ul>
          <button class = "btn" :class = "{ selected: searchParams.is_finished }" v-on:click = "toggleIsFinished()">Terminado</button>
          <button class = "btn" :class = "{ selected: searchParams.is_public }" v-on:click = "toggleIsPublic()">Publico</button>
        </ul>
      </div>

      <!-- {{searchParams}} -->
      <div class = "filter" v-if = "categories.includes('calls')">
        <h3 v-if = "showTitles">Convocatorias</h3>
        <ul>
          <button class = "btn" :class = "{ selected: '' === searchParams.call }" v-on:click = "selectCall('')">Todas</button>
          <button class = "btn" :class = "{ selected: c.id === searchParams.call }" v-for = "c in calls" v-on:click = "selectCall(c.id)" :key = "c.id">
            {{c.name}}
            <span v-if = "showId"> ({{c.id}})</span>
          </button>
        </ul>
      </div>

      <div class = "filter" v-if = "categories.includes('tags')">
        <h3 v-if = "showTitles">Tags</h3>
        <ul>
          <button class = "btn" v-for = "t in tags" :class = "{ selected: searchParams.tags.includes(t.id) }" v-on:click = "selectTag(t)" :key = "t.id">
            {{t.name}}
            <span v-if = "showId"> ({{t.id}})</span>
          </button>
        </ul>
      </div>

      <div class = "filter" v-if = "categories.includes('codeanalysis')">
        <h3 v-if = "showTitles">CodeAnalysis</h3>
        <ul>
          <button class = "btn" v-for = "o in codeAnalysisMetadata.actions.POST" :class = "{ selected: codeAnalysisLabel(o) in searchParams.codeAnalysis }" :key = "o.label" v-if = "o.read_only === false && o.type === 'boolean'" v-on:click = "selectCodeAnalysis(o)">
            {{o.label}}
            <span v-if = "showId"> ({{o.id}})</span>
          </button>
        </ul>
      </div>
    </div>

    <button v-if = "false" v-on:click = "fetch" class = "btn btn-bg">fetch</button>
  </div>
</template>

<script>
export default {
  name: 'GalleryFilter',
  props: {
    searchParams: Object,
    categories: Array,
    showTitles: Boolean,
    showId: {
      default: false
    }
  },
  computed: {
    tags: function () {
      return this.$store.state.gallery.tags
    },
    calls: function () {
      return this.$store.state.gallery.calls
    },
    codeAnalysisMetadata: function () {
      return this.$store.state.gallery.codeAnalysisMetadata
    }
  },
  methods: {
    fetch: function () {
      this.searchParams.page = 1
      let query = {
        params: this.searchParams
        /* {
          page: this.$route.params.page,
          call: this.call,
          tags: this.tags
        }
        */
      }

      this.$store.dispatch('fetchProjectList', query)

      // FIXME this is a hack
      if (this.$route.name === 'Gallery') {
        this.$router.push({ name: 'Gallery', params: { 'page': 1 } })
      }
    },
    toggleIsFinished: function () {
      this.searchParams.is_finished = !this.searchParams.is_finished
      this.fetch()
    },
    toggleIsPublic: function () {
      this.searchParams.is_public = !this.searchParams.is_public
      this.fetch()
    },
    selectCall: function (callId) {
      console.log('select call', callId)
      this.searchParams.call = callId
      this.fetch()

      /*
      this.call = call.id

      if (call.id in this.searchParams.calls) {
        this.$delete(this.searchParams.calls, call.id)
      } else {
        this.$set(this.searchParams.calls, call.id, call)
      }
      */
    },
    selectTag: function (tag) {
      console.log('select tag', tag.id)

      if (this.searchParams.tags.includes(tag.id)) {
        let index = this.searchParams.tags.indexOf(tag.id)
        this.searchParams.tags.splice(index, 1)
      } else {
        this.searchParams.tags.push(tag.id)
      }
      this.fetch()
    },
    selectCodeAnalysis: function (codeAnalysis) {
      let label = this.codeAnalysisLabel(codeAnalysis)
      console.log('select codeAnalysis', label)

      if (label in this.searchParams.codeAnalysis) {
        this.$delete(this.searchParams.codeAnalysis, label)
      } else {
        this.$set(this.searchParams.codeAnalysis, label, true)
      }
      this.fetch()
    },
    codeAnalysisLabel: function (codeAnalysis) {
      return codeAnalysis.label.replace(/ /g, '_').toLowerCase()
    }
  },
  created () {
    this.$store.dispatch('fetchTagList')
    this.$store.dispatch('fetchCallList')
    this.$store.dispatch('fetchCodeAnalysisMetadata')
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.gallery-filter {
  // background: @accentColor;
  // margin: 20px 0;
  // padding: 12px;
}

.filter {
  padding: 10px 10px 10px 0px;

  h3 {
    color: black;
  }

  ul {
    margin: 0;
  }

  button {
    color: #000a;
    background: #0003;
    padding: 5px 8px;
    border-radius: 2px;
    // box-shadow: 1px 1px 1px 0px #0002;
    display: inline-block;
    margin: 5px 10px 5px 0px;
    text-align: left;

    &.selected {
      color: white;
      background: #222;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery/GalleryFilter.vue